import axios from 'axios';
import { getApiHeader } from './../services/getApiHeaders';

export function getSummary() {
    const options = {
        method: 'GET',
        url: process.env.REACT_APP_URL + '/api/common/getheadsummary',
        withCredentials: true,
        headers: getApiHeader(),
    }
    return axios(options)
}



// WEBPACK FOOTER //
// ./src/utils/headerSummary.js